import { jsx } from "react/jsx-runtime";
import { ControlValue } from "./control";
function ShapeControlValue({
  definition,
  data,
  children,
  control
}) {
  return Object.entries(definition.config.type).reduceRight(
    (renderFn, [key, controlDefinition]) => (shapeControlValue) => /* @__PURE__ */ jsx(
      ControlValue,
      {
        definition: controlDefinition,
        data: data?.[key],
        control: control?.controls.get(key),
        children: (value) => renderFn({ ...shapeControlValue, [key]: value })
      }
    ),
    children
  )({});
}
export {
  ShapeControlValue
};
//# sourceMappingURL=shape.js.map